import React, { useState } from 'react';
import Chair from './Chair';
import ChairPopup from './ChairPopup';
import '../styles/ChairGrid.css';
import { ChairGridProps, Occupant } from '../types';

const ChairGrid: React.FC<ChairGridProps> = ({ chairs, selectedChairs, onChairClick, occupants }) => {
  const [popupData, setPopupData] = useState<{ 
    show: boolean; 
    occupant: Occupant | null; 
    position: { x: number; y: number } 
  }>({ show: false, occupant: null, position: { x: 0, y: 0 } });

  const handleChairHover = (chairNumber: number, occupant: Occupant): void => {
    setPopupData({
      show: true,
      occupant: occupant,
      position: { x: 0, y: 0 } // Will be updated by individual chair
    });
  };

  const handleChairLeave = (chairNumber: number): void => {
    setPopupData({
      show: false,
      occupant: null,
      position: { x: 0, y: 0 }
    });
  };

  return (
    <div className="chair-grid">
      {chairs.map((chairNumber) => (
        <Chair
          key={chairNumber}
          chairNumber={chairNumber}
          isSelected={selectedChairs.includes(chairNumber)}
          onClick={onChairClick}
          occupant={occupants[chairNumber]}
          onHover={handleChairHover}
          onLeave={handleChairLeave}
        />
      ))}
      <ChairPopup
        occupant={popupData.occupant}
        isVisible={popupData.show}
        position={popupData.position}
      />
    </div>
  );
};

export default ChairGrid;
